import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchAndParseContent} from "../contenful/ContentfulActions";
import {KycStatus, Settings, UserInfo} from "../http/protocol";
import {AppState} from "../RootReducer";
import {setMetamapStatus as setMetamapStatus} from "../user/UserActions";
import "./styles/MetamapComponent.scss";
import {usePrevious} from "../user/ui/utils";

export const MetamapComponent = (
            props : {
                clicked?: boolean,
                exited? : () => void
            }
        ) => {
    const settings = useSelector((app : AppState) => app.settings.settings);
    const user = useSelector((app : AppState) => app.user);
    const kycRequired : boolean = !!(user.metamapStatus == KycStatus.NOT_STARTED && user?.user?.kycVerified == false);
    const metamapEnabled = settings?.matiEnabled ?? false;

    const dispatch = useDispatch();

    const [verifyInProgressModalShow, setVerifyInProgressModalShow] = useState(false);
    const findMetamapButton = () => document.querySelector<HTMLButtonElement>(".metamap-container #mati-button");
    const handleAutomaticClick = () => {
        setVerifyInProgressModalShow(!verifyInProgressModalShow);
        // Find Metamap button that is a child to the container. We can't search globally in the document as we have multiple Metamap components.
        findMetamapButton()?.click()
    };
    const prevClicked = usePrevious(props.clicked);

    useEffect(()=>{
        if (props.clicked && !prevClicked) {
            handleAutomaticClick();
        }
    },[props.clicked, prevClicked]);

    useEffect(()=>{
        const finishListener = (event: Event) => {
            console.log("metamap:userFinishedSdk",event);
            dispatch(setMetamapStatus(KycStatus.PENDING))
        };
        const exitListener = (event: Event) => {
            console.log("metamap:exitedSdk",event);
            dispatch(setMetamapStatus(KycStatus.NOT_STARTED))
            props.exited?.();
        };
        const startedListener = (e : Event) => {
            console.log('metamap started payload', e)
        };
        const loadedListener = (e : Event) => {
            console.log('metamap loaded payload', e)
        };
        const button = findMetamapButton();
        if (button) {
            console.log("metamap adding event listener")
            button.addEventListener('metamap:userFinishedSdk', finishListener)
            button.addEventListener('metamap:exitedSdk', exitListener)
            button.addEventListener('metamap:loaded', loadedListener);
            button.addEventListener('metamap:userStartedSdk', startedListener);

        } else {
            console.log("Unable to find metamap button");
        }
        return () => {
            if (button) {
                console.log("metamap removing event listener")
                button.removeEventListener('mati:userFinishedSdk', finishListener)
                button.removeEventListener('mati:exitedSdk', exitListener)
                button.removeEventListener('mati:loaded', loadedListener);
                button.removeEventListener('mati:userStartedSdk', startedListener);

            }
        }
    },[dispatch])

    if(!settings?.matiClientId || !metamapEnabled || !kycRequired || !user.user?.userUid) {
        return <></>
    }

    let clientId = settings?.matiClientId;
    let flowId;
    if(clientId && clientId.indexOf(":") != -1) {
        let parts = clientId.split(":");
        if(parts.length == 2) {
            clientId = parts[0];
            flowId = parts[1];
        }
    }
    const userUid = user.user?.userUid;
    const userEmail = user.user?.email;
    const userPhone = user.user?.phoneNumber;

    const metadata  = JSON.stringify({
        user_id : userUid
    });
    console.log("clientId = " + clientId + ", flowId = " + flowId);
    if(flowId) {
        return (
            <div id={"metamap-container"} className={"metamap-container"}>
            <span dangerouslySetInnerHTML={{
                __html: `
                    <metamap-button 
                        id="mati-button"
                        clientId="${clientId}"
                        flowId="${flowId}"
                        metadata='${metadata}'
                    ></metamap-button>                                        
                `
            }}/>
            </div>
        )
    }
    return (
        <div id={"metamap-container"} className={"metamap-container"}>
            <span dangerouslySetInnerHTML={{
                __html: `
                    <metamap-button 
                        id="mati-button"
                        clientId="${clientId}"
                        metadata='${metadata}'
                    ></metamap-button>                                        
                `}} />
        </div>
    )
}
interface PropsFromState {
    settings?: Settings;
    user? : UserInfo;
    lng: string;
}

interface PropsFromDispatch {
    fetchContent?: typeof fetchAndParseContent;
    setMetamapStatus: (status: KycStatus) => void;
}


const MetamapComponentWrapper = (
    props : {
        clicked?: boolean,
        exited? : () => void
    }) => {
    const settings = useSelector((app : AppState) => app.settings.settings);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const  loadScript = () => {
        let id = 'metamap'
        if (!scriptLoaded && (document.getElementById(id))) {
            setScriptLoaded(true);
        } else if(!scriptLoaded) {
            let script = document.createElement('script')
            script.async = true;
            script.type = 'text/javascript'
            script.src = 'https://web-button.getmati.com/button.js'
            script.id = id;
            script.addEventListener("load", ()=>{
                console.log("metamap button script loaded");
                setScriptLoaded(true);
            })
            document.head.appendChild(script);
        }
    }

    useEffect(()=>{
        if(settings?.matiEnabled && !scriptLoaded) {
            loadScript();
        }
    },[settings?.matiEnabled, scriptLoaded])

    return <>{scriptLoaded && <MetamapComponent {...props} />}</>
}

export default MetamapComponentWrapper;